import ol_control_SearchNominatim from "ol-ext/control/SearchNominatim.js";

export default class SearchNominatim extends ol_control_SearchNominatim {
    constructor(options) {
        options = options || {};
        options.className = options.className || 'nominatim';
        options.typing = options.typing || -1;
        options.copy = '<a href="http://www.openstreetmap.org/copyright" target="new">&copy; OpenStree' +
                'tMap contributors</a>';
        options.url = 'https://nominatim.openstreetmap.org/search';
        options.historyText = options.historyText
            ? options.historyText
            : 'History';
        super(options);

        var datas_ = {
            type: options.type,
            historyText: options.historyText,
            searchResultText: options.searchResultText,
            noItemsText: options.noItemsText
        };
        this.set('polygon', options.polygon);
        this.set('viewbox', options.viewbox);
        this.set('bounded', options.bounded);
        this.set('key', options.key);
        this.set('language', options.language);
        this.set('type', options.type);
        this.set('search_country', options.searchCountry);
        this.set('_LocFunction', options._LocFunction);
        this.set('datas_', datas_);

        if (options.searchByPostal == 'True' || options.searchByPostal == true) {
            this.set('search_postal', options.searchPostal);
            this.set('search_city', options.searchCity);
        } else {
            this.set('search_city', options.searchCity);
        }

    }
    /** Returns the text to be displayed in the menu
       *	@param {ol.Feature} f the feature
      *	@return {string} the text to be displayed in the index
      *	@api
      */
    getTitle(f) {
        var info = [];
        if (f.class) 
            info.push(f.class);
        if (f.type) 
            info.push(f.type);
        var title = f.display_name + (
            info.length
                ? "<i>" + info.join(' - ') + "</i>"
                : ''
        );
        if (f.icon) 
            title = "<img src='" + f.icon + "' />" + title;
        return (title);
    }
    /**
       * @param {string} s the search string
       * @return {Object} request data (as key:value)
       * @api
       */
    requestData(s) {

        var cName = this.get('search_city')
            ? ', ' + this.get('search_city')
            : '';
        var cZip = this.get('search_postal')
            ? ', ' + this.get('search_postal')
            : '';

        var isLocation = false;

        if (s.includes(',')) {

            function isNumeric(str) {
                if (typeof str != "string") 
                    return false // we only process strings!
                return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
                !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
            }

            var first = s.split(',')[0];
            var last = s.split(',')[1];
            if (isNumeric(first) && isNumeric(last)) {
                isLocation = true;
            }
        }

        if (isLocation == true) {

            var first = parseFloat(s.split(',')[0]);
            var last = parseFloat(s.split(',')[1]);

            return {
                format: "json",
                addressdetails: 0,
                q: s, 
                isLocation: isLocation, 
                first: first, 
                last: last,
                polygon_geojson: 0,
                bounded: 0,
                limit: 10,
            };

        } else {

            var cityQueries;

            if (this.get('search_city') != null && this.get('search_city') != '') {
                cityQueries = [];
                var cityName = this.get('search_city');
                cityName
                    .split(' ')
                    .forEach(ciName => {
                        cityQueries.push(s + ', ' + ciName + cZip);
                    });
                if (cityQueries.length <= 1) {
                    cityQueries = null;
                }
            }

            var data = {
                format: "json",
                addressdetails: 1,
                q: s + cName + cZip,
                polygon_geojson: this.get('polygon')
                    ? 1
                    : 0,
                bounded: this.get('bounded')
                    ? 1
                    : 0,
                limit: this.get('maxItems'),
                extratags: 1,
                namedetails: 1,
                countrycodes: this.get('search_country') != null
                    ? this.get('search_country')
                    : '',
                // city: this.get('search_city') != null ? this.get('search_city') : '',
                // postalcode: this.get('search_postal') != null ? this.get('search_postal') :
                // '',
                cityQueries: cityQueries
            };
            if (this.get('viewbox')) 
                data.viewbox = this.get('viewbox');
            return data;

        }
    }

    /** A ligne has been clicked in the menu > dispatch event
       *	@param {any} f the feature, as passed in the autocomplete
      *	@api
      */
    select(f) {
        var c = [
            Number(f.lon),
            Number(f.lat)
        ];
        // Add coordinate to the event
        try {
            c = ol_proj_transform(c, 'EPSG:4326', this.getMap().getView().getProjection());
        } catch (e) {/* ok */
        }
        this.dispatchEvent({type: "select", search: f, coordinate: c});
    }

    /** Reverse geocode
       * @param {ol.coordinate} coord
       * @api
       */
    reverseGeocode(coord, cback) {
        var lonlat = ol_proj_transform(
            coord,
            this.getMap().getView().getProjection(),
            'EPSG:4326'
        );
        this.ajax(this.get('url').replace('search', 'reverse'), {
            lon: lonlat[0],
            lat: lonlat[1],
            format: 'json'
        }, function (resp) {
            if (cback) {
                cback.call(this, [resp]);
            } else {
                if (resp && !resp.error) {
                    this._handleSelect(resp, true);
                }
                //this.setInput('', true);
            }
        }.bind(this));
    }

    /**
       * Handle server response to pass the features array to the display list
       * @param {any} response server response
       * @return {Array<any>} an array of feature
       * @api
       */
    handleResponse(response) {
        return response.results || response;
    }

    /** Draw the list
      * @param {Array} auto an array of search result
      * @private
      */
    drawList_(auto, fromHistory) {
        var this_datas = this.get('datas_');
        var self = this;
        var ul = this
            .element
            .querySelector("ul.autocomplete");
        ul.innerHTML = '';
        this._list = [];

        var isSearch = true;

        if (!auto) {
            var input = this
                .element
                .querySelector("input.search");
            var value = input.value;
            if (!value || fromHistory == true) {
                auto = this.get('history');
            } else {
                return;
            }
            var historyText = this_datas
                ? this_datas['historyText']
                    ? this_datas['historyText']
                    : 'History'
                : 'History';
            ul.setAttribute('class', 'autocomplete history');
            // this._h6.innerHTML = historyText + ':';
            if (this._remove) {
                this._remove.style.display = 'inline-block';
            }
            isSearch = false;
        } else {
            ul.setAttribute('class', 'autocomplete');
            var searchResultText = this_datas
                ? this_datas['searchResultText']
                    ? this_datas['searchResultText']
                    : 'Search result'
                : 'Search result';
            // this._h6.innerHTML = searchResultText + ':';
            if (this._remove) {
                this._remove.style.display = 'none';
            }
        }

        var noItemsText = this_datas
            ? this_datas['noItemsText']
                ? this_datas['noItemsText']
                : 'No items'
            : 'No items';

        if (auto['isLocation'] == true) {

            const coords = [auto.last, auto.first];

            var datta = [
                {
                    "boundingbox": auto['q'],
                    "display_name": auto['q'],
                    "address": auto['q'],
                    "geojson": {
                        "type": "Point",
                        "coordinates": coords
                    },
                    "namedetails": {
                        "name": auto['q'],
                        "name:en": auto['q'],
                        "alt_name": auto['q']
                    }
                }
            ];

            var li,
                max = Math.min(self.get("maxItems"), datta.length);

            if (auto.length == 0) {

                li = document.createElement("LI");
                li.innerHTML = noItemsText;
                ul.appendChild(li);

            } else {

                for (var i = 0; i < max; i++) {
                    if (datta[i]) {
                        if (!i || !self.equalFeatures(datta[i], datta[i - 1])) {
                            if (datta[i]['type'] === 'FeatureCollection') {
                                li = document.createElement("LI");
                                li.setAttribute("data-search", this._list.length);
                                this
                                    ._list
                                    .push(datta[i]);
                                li.addEventListener("click", function (e) {
                                    self._handleSelect(self._list[
                                        e
                                            .currentTarget
                                            .getAttribute("data-search")
                                    ]);
                                });
                                var title = self.getTitle(datta[i]['features'][0]['properties']);
                                if (title instanceof Element) 
                                    li.appendChild(title);
                                else 
                                    li.innerHTML = title;
                                ul.appendChild(li);
                            } else {
                                li = document.createElement("LI");
                                li.setAttribute("data-search", this._list.length);
                                this
                                    ._list
                                    .push(datta[i]);
                                li.addEventListener("click", function (e) {
                                    self._handleSelect(self._list[
                                        e
                                            .currentTarget
                                            .getAttribute("data-search")
                                    ]);
                                });
                                var title = self.getTitle(datta[i]);
                                if (title instanceof Element) 
                                    li.appendChild(title);
                                else 
                                    li.innerHTML = title;
                                ul.appendChild(li);
                            }
                        }
                    }
                }

            }

        } else {

            if (isSearch) {

                var postal = this.get('search_postal');

                if (postal) {

                    var newAuto = [];

                    auto.forEach(aut => {
                        var address = aut['address'];
                        if (address) {
                            if (address['postcode'] == postal) {
                                newAuto.push(aut);
                            }
                        } else {
                            if (aut['display_name'].includes(postal)) {
                                newAuto.push(aut);
                            }
                        }
                    });

                    auto = newAuto;

                }
            }

            var li,
                max = Math.min(self.get("maxItems"), auto.length);

            if (auto.length == 0) {
                li = document.createElement("LI");
                li.innerHTML = noItemsText;
                ul.appendChild(li);
            } else {

                for (var i = 0; i < max; i++) {
                    if (auto[i]) {
                        if (!i || !self.equalFeatures(auto[i], auto[i - 1])) {
                            if (auto[i]['type'] === 'FeatureCollection') {
                                li = document.createElement("LI");
                                li.setAttribute("data-search", this._list.length);
                                this
                                    ._list
                                    .push(auto[i]);
                                li.addEventListener("click", function (e) {
                                    self._handleSelect(self._list[
                                        e
                                            .currentTarget
                                            .getAttribute("data-search")
                                    ]);
                                });
                                var title = self.getTitle(auto[i]['features'][0]['properties']);
                                if (title instanceof Element) 
                                    li.appendChild(title);
                                else 
                                    li.innerHTML = title;
                                ul.appendChild(li);
                            } else {
                                li = document.createElement("LI");
                                li.setAttribute("data-search", this._list.length);
                                this
                                    ._list
                                    .push(auto[i]);
                                li.addEventListener("click", function (e) {
                                    self._handleSelect(self._list[
                                        e
                                            .currentTarget
                                            .getAttribute("data-search")
                                    ]);
                                });
                                var title = self.getTitle(auto[i]);
                                if (title instanceof Element) 
                                    li.appendChild(title);
                                else 
                                    li.innerHTML = title;
                                ul.appendChild(li);
                            }
                        }
                    }
                }
                if (max && this.get("copy")) {
                    li = document.createElement("LI");
                    li
                        .classList
                        .add("copy");
                    li.innerHTML = this.get("copy");
                    ul.appendChild(li);
                }
            }
        }
    }
}
